import {Component, Input, OnInit} from '@angular/core';
import {SharedService} from '../../shared/shared.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
  private _title;
  @Input('title') set title(val) {
    this._title = val;
  }

  get title() {
    return this._title;
  }

  constructor(public sharedService: SharedService) {
  }

  ngOnInit(): void {
  }

}
